import React, { useState, useRef, useEffect, useContext } from "react";
import "./SignatureCredetialForm.css";
import { Dialog } from "@progress/kendo-react-dialogs";
import FirmaautografaGris from "../../../assets/logos/icons/firmaautografa_gris@2x.png";
import CredencialGris from "../../../assets/logos/icons/credencial_gris@2x.png";
import CanvasDraw from "@win11react/react-canvas-draw";
import { CheckBoxHLPure, SimpleLoading, ValidationCodePure, ButtonHLPure } from "../../pures";
import Cancel from "../../../assets/logos/icons/cancel.png";
import IneFrontTemplate from "../../../assets/logos/icons/frente_INEjpg.jpg";
import IneBackTemplate from "../../../assets/logos/icons/vuelta_reverso.jpg";
import Done from "../../../assets/logos/icons/done.png";
import { Context } from "../../../Context";
import Warning from "../../../assets/logos/icons/warning.png";
import { getStampTimeAndTimezone } from "../../../utils";
import { PlusBlue } from "../../../assets/logos/icons";

function setTextInCanvas(y, text) {
  try {
    let sourceCanvas = document.getElementsByTagName("canvas")[1];
    let ctx = sourceCanvas.getContext("2d");
    ctx.font = "bold 23px Arial";
    ctx.textAlign = "center";
    ctx.fillText(text, sourceCanvas.width / 2, y);
  } catch (error) { }
}

const saveImage = () => {
  let sourceCanvas = document.getElementsByTagName("canvas")[1];
  let destinationCanvas = document.createElement("canvas");
  destinationCanvas.height = sourceCanvas.height;
  destinationCanvas.width = sourceCanvas.width;
  let destinationContext = destinationCanvas.getContext("2d");
  destinationContext.drawImage(sourceCanvas, 0, 0);
  destinationContext.globalCompositeOperation = "destination-over";
  destinationContext.fillStyle = "#4484a500";
  destinationContext.fillRect(
    0,
    0,
    destinationCanvas.width,
    destinationCanvas.height
  );
  let image = destinationCanvas.toDataURL("image/png");
  return image;
};

export default function SignatureCredetialForm({
  onClose,
  children,
  isLoadingUserDocSupp,
  errorUserDocSupp,
  signatureImg,
  ineFrontImg,
  ineBackImg,
  changeUserDocSupps,
  toggleErrorUserDocRequesting,
  errorWarningDoc,
  sendUserDocSupps,
  firstName,
  lastName,
  saveImagesSuccess,
  t,
  onErrorTimeStamp
}) {
  const { visibleDialogTimerSignOff } = useContext(Context);
  const [step, setStep] = useState(
    signatureImg && ineFrontImg && ineBackImg ? 3 : 0
  );
  const [imgSignature, setImgSignature] = useState(signatureImg);
  const [ineFront, setIneFront] = useState(ineFrontImg);
  const [ineBack, setIineBack] = useState(ineBackImg);
  const [nip, setNip] = useState('');
  const [validateNip, setValidateNip] = useState('');
  const [nipEnabled, setNipEnable] = useState(false);
  const [errorNip, setErrorNip] = useState(false)
  // const [step, setStep] = useState(0)
  // const [imgSignature, setImgSignature] = useState(null)
  // const [ineFront, setIneFront] = useState(null)
  // const [ineBack, setIineBack] = useState(null)
  const [signatureData, setSignatureData] = useState(new FormData());
  const inputFrontIne = useRef(null);
  const inputBackIne = useRef(null);
  const pad = useRef(null);
  const uploadFile = (ref) => ref.current.click();
  const onImageChange = (event, set, key) => {
    if (event.target.files && event.target.files[0]) {
      let type = event.target.files[0].type.split("/");
      if (type[0] === "image" && event.target.files[0].type !== "image/tiff") {
        let reader = new FileReader();
        reader.onload = (e) => {
          let im = new Image();
          im.src = e.target.result;
          im.onload = () => {
            set(e.target.result);
          };
        };
        signatureData.delete(key);
        signatureData.append(key, event.target.files[0]);
        reader.readAsDataURL(event.target.files[0]);
        reader = null;
      } else {
        console.log("error");
        toggleErrorUserDocRequesting(
          "Por favor selecciona una imagen válida para continuar (png, jpg, jpeg)."
        );
      }
    }
  };

  const urlToBlob = async (url, key) =>
    await fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], key + ".png");
        signatureData.delete(key);
        signatureData.append(key, file);
      });

  const sendData = () => {
    if (nip !== validateNip) {
      setErrorNip(true)
      return false
    }
    setErrorNip(false)

    signatureData.append("nip", nip);
    signatureData.append("nipEnabled", nipEnabled);
    if (signatureImg && ineFrontImg && ineBackImg) {
      changeUserDocSupps(signatureData, () => onClose());
    } else sendUserDocSupps(signatureData, () => onClose());
  }


  const handleCheckBox = (e) => {
    setNipEnable(e.target.checked);
  };

  const getOperatingSystem = () => {
    let operatingSystem = "Not known";
    if (window.navigator.appVersion.indexOf("Win") !== -1) {
      operatingSystem = "Windows OS";
    }
    if (window.navigator.appVersion.indexOf("Mac") !== -1) {
      operatingSystem = "MacOS";
    }
    if (window.navigator.appVersion.indexOf("X11") !== -1) {
      operatingSystem = "UNIX OS";
    }
    if (window.navigator.appVersion.indexOf("Linux") !== -1) {
      operatingSystem = "Linux OS";
    }
    return operatingSystem;
  };

  const getBrowser = () => {
    let currentBrowser = "Not known";
    if (window.navigator.userAgent.indexOf("Chrome") !== -1) {
      currentBrowser = "Google Chrome";
    } else if (window.navigator.userAgent.indexOf("Firefox") !== -1) {
      currentBrowser = "Mozilla Firefox";
    } else if (window.navigator.userAgent.indexOf("MSIE") !== -1) {
      currentBrowser = "Internet Exployer";
    } else if (window.navigator.userAgent.indexOf("Edge") !== -1) {
      currentBrowser = "Edge";
    } else if (window.navigator.userAgent.indexOf("Safari") !== -1) {
      currentBrowser = "Safari";
    } else if (window.navigator.userAgent.indexOf("Opera") !== -1) {
      currentBrowser = "Opera";
    } else if (window.navigator.userAgent.indexOf("Opera") !== -1) {
      currentBrowser = "YaBrowser";
    }
    return currentBrowser;
  };

  useEffect(() => {
    let infodevice = navigator.userAgent;
    let deviceBody = "Pc";
    if (infodevice.includes("mac")) deviceBody = "Mac";
    if (infodevice.includes("windows")) deviceBody = "Pc";
    if (infodevice.includes("android")) deviceBody = "Android";
    if (infodevice.includes("iphone")) deviceBody = "iPhone";
    if (infodevice.includes("ipad")) deviceBody = "iPad";
    if (infodevice.includes("mobile")) deviceBody = "Mobile";
    signatureData.append("deviceBody", deviceBody);
    signatureData.append("osBody", getOperatingSystem());
    signatureData.append("browserBody", getBrowser());
    signatureData.append("interfaceBody", "MiFirma-Web");
    if (signatureImg) urlToBlob(signatureImg, "signImage");
    if (ineFrontImg) urlToBlob(ineFrontImg, "ineFrontImage");
    if (ineBackImg) urlToBlob(ineBackImg, "ineBackImage");
  }, []);

  useEffect(() => {
    urlToBlob(imgSignature, "signImage");
  }, [imgSignature]);

  const setUserDataInCanvas = () =>
    setTimeout(async () => {
      const stampTime = await getStampTimeAndTimezone()
      if (stampTime === false) {
        onErrorTimeStamp()
        onClose()
      }
      if (firstName.length + lastName.length > 26) {
        setTextInCanvas(240, `${firstName}`)
        setTextInCanvas(270, `${lastName}`)

      } else {
        setTextInCanvas(270, `${firstName} ${lastName}`)
      }
      // setTextInCanvas(270, `${firstName} ${lastNamae}`);
      // setTextInCanvas(245, firstName);
      // setTextInCanvas(270, lastNamae);
      // setTextInCanvas(295, `${stampTime}`);
    }, 100);

  useEffect(() => {
    if (step === 2) {
      setUserDataInCanvas();
    }
  }, [step]);

  const getTitle = () => {
    if (
      isLoadingUserDocSupp ||
      saveImagesSuccess ||
      errorUserDocSupp ||
      errorWarningDoc
    )
      return "govo.legal";
    return step === 0
      ? "Cargar elementos de referencia"
      : "Captura tu firma autógrafa";
  };

  if (visibleDialogTimerSignOff) return <React.Fragment />;

  return !!isLoadingUserDocSupp ||
    !!errorUserDocSupp ||
    !!saveImagesSuccess ||
    !!errorWarningDoc ? (
    <Dialog
      className="signatureCredentialForm-form"
      title={getTitle()}
      onClose={onClose}
    >
      {saveImagesSuccess ? (
        <div className="download-loading">
          <img src={Done} />
          <p className="text-container">
            {t("dialogSignRequestPure.requestSucces")}
          </p>
        </div>
      ) : isLoadingUserDocSupp ? (
        <div className="error-user-docSupp">
          <SimpleLoading />
          <p className="text-container">
            {t("dialogSignRequestPure.titleExecutingRequest")}
          </p>
        </div>
      ) : errorWarningDoc ? (
        <div className="error-user-docSupp">
          <img src={Warning} />
          <p className="text-container">
            {errorWarningDoc
              ? errorWarningDoc
              : t("dialogSignRequestPure.titleErrorRequesting")}
          </p>
        </div>
      ) : (
        <div className="error-user-docSupp">
          <img src={Cancel} />
          <p className="text-container">
            {t("dialogSignRequestPure.titleErrorRequesting")}
          </p>
        </div>
      )}
    </Dialog>
  ) : (
    <Dialog
      className="signatureCredentialForm-form"
      title={
        step === 0
          ? "Cargar elementos de referencia"
          : "Captura tu firma autógrafa"
      }
      onClose={onClose}
    >
      {step !== 3 && (
        <div className="modal-header">
          <div className="circle-title">
            <div
              className={`img-circle ${(step === 1 || step === 2) &&
                "signatureCredetialForm-border-stepper"
                } `}
            >
              <img src={FirmaautografaGris} />
            </div>
            <h4>Firma</h4>
            <h4>autógrafa</h4>
          </div>
          <div className="divider" />
          <div className="circle-title">
            <div
              className={`img-circle ${(step === 0 || step === 1) &&
                "signatureCredetialForm-border-stepper"
                } `}
            >
              <img src={CredencialGris} />
            </div>
            <h4>Credencial</h4>
            <h4>para votar</h4>
          </div>
        </div>
      )}
      <div className="description">
        {step === 2 ? (
          <>
            {children}
            <p className="p-principal">
              {
                "Para capturar la firma presiona el botón izquierdo del ratón y desliza, para terminar el trazo suelta el botón, repite esta acción hasta terminar de firmar y da clic en capturar firma. En caso de usar una tablet presiona con la pluma o u dedo hasta que termines de capturar la firma."
              }
            </p>
          </>
        ) : (
          <p className="p-principal">
            {
              "Te sugerimos adjuntar tu documento de identidad (credencial para votar) y ejecutar un ejercicio de firma autógrafa digital para que tengas elementos de referencia útiles en caso de litigios y elaboración de peritajes."
            }
          </p>
        )}
      </div>
      {step !== 2 ? (
        <div className="rectangles">
          {(step === 0 || step === 3) && (
            <div>
              <div
                className={`rec-signature-base ${ineFront && step === 3 && "disable-cursor"
                  }`}
                onClick={() => step === 0 && uploadFile(inputFrontIne)}
              >
                {(step === 0) && <img src={PlusBlue} width="40" />}
                <img
                  className={`shasow-ime ${ineFront && "opacity-1"}`}
                  src={ineFront ? ineFront : IneFrontTemplate}
                />
              </div>
              {(step === 0) && (
                <p className="signatureCredretialForm-p-sub">
                  {"Cargar credencial frontal"}
                </p>
              )}
              <div>
                <div
                  className={`rec-signature-base ${ineBack && step === 3 && "disable-cursor"
                    }`}
                  onClick={() => step === 0 && uploadFile(inputBackIne)}
                >
                  {(step === 0) && <img src={PlusBlue} width="40" />}
                  <img
                    className={`shasow-ime ${ineBack && "opacity-1"}`}
                    src={ineBack ? ineBack : IneBackTemplate}
                  />
                </div>
                {(step === 0) && (
                  <p className="signatureCredretialForm-p-sub">
                    {"Cargar credencial posterior"}
                  </p>
                )}
              </div>
            </div>
          )}
          {(step === 1 || step === 3) && (
            <div>
              <div
                className={`rec-signature-base ${imgSignature && step === 3 && "disable-cursor"
                  }`}
                onClick={() => (step === 0 || step === 1) && setStep(2)}
              >
                {(step === 0 || step === 1) && (
                  <img src={PlusBlue} width="40" />
                )}
                {imgSignature && (
                  <img
                    className={`shasow-ime ${imgSignature && "opacity-1"}`}
                    src={imgSignature}
                  />
                )}
                {(step === 0 || step === 1) && !imgSignature && (
                  <>
                    <p className="sub-title">{firstName}</p>
                    <p className="sub-title-2">{lastName}</p>
                  </>
                )}
              </div>
              {(step === 0 || step === 1) && (
                <p className="signatureCredetialForm-p-sub">
                  {"Captura tu firma autógrafa"}
                </p>
              )}
              {step === 3 && imgSignature && (
                <div>
                  <div
                    className={'rec-signature-base disable-cursor'
                    }
                  >
                    <p>
                      {t("signatureRequestDetailAction2.protectedSignatureText")}
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className={"signatureCredretialForm-canvas-draw"}>
          <CanvasDraw
            ref={pad}
            loadTimeOffset={0}
            lazyRadius={2}
            brushRadius={2}
            brushColor={"#000"}
            catenaryColor={"#0a0302"}
            gridColor={"rgba(150,150,150,0.17)"}
            hideGrid={true}
            canvasWidth={"95%"}
            canvasHeight={300}
            disabled={false}
            immediateLoading={true}
            hideInterface={false}
          />
        </div>
      )}
      {(step === 1) && (
        <div>
          <div style={{ paddingTop: '10px' }}>
            <ValidationCodePure
              data={nip}
              setData={setNip}
              validationLength={4}
              title={'NIP de Firma Base'}
              hide={true}
            />
          </div>

          <div>
            <ValidationCodePure
              data={validateNip}
              setData={setValidateNip}
              validationLength={4}
              title={'Repetir NIP'}
              hide={true}
            />
          </div>
          <div className="checkbox-font">
            <CheckBoxHLPure
              valueCheckBox={true}
              checkedState={nipEnabled}
              labelCheckBox={t("signatureRequestDetailAction2.authorizeNIP")}
              onChangeHandler={handleCheckBox}
            />
          </div>
          <div>
            {errorNip && (
              <div style={{ marginLeft: "5px", textAlign: 'center' }}>
                <span className="hint-message-error">
                  {t("El NIP proporcionado no coincide.")}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
      <div className="btn-container">
        {step === 0 || step === 3 ? (
          <ButtonHLPure
            nameBtn="Cancelar"
            onClickBtn={() => onClose()}
          />
        ) : (
          <ButtonHLPure
            nameBtn="Atras"
            onClickBtn={() => setStep(step - 1)} />
        )}
        {step === 0 && (
          <ButtonHLPure
            disabled={!ineFront && !ineBack}
            nameBtn="Siguiente"
            primary
            onClickBtn={() => setStep(1)}
          />
        )}
        {step === 1 && (
          <ButtonHLPure
            nameBtn="Guardar"
            primary
            className={`signatureCredentialForm-credential-primary ${(!signatureImg &&
              !imgSignature || !nipEnabled) &&
              "signatureCredentialForm-disable-btn"
              }`}
            disabled={(!signatureImg && !imgSignature) || !nipEnabled || (nip.length !== 4 || validateNip.length !== 4)}
            onClickBtn={sendData}
          />
        )}
        {step === 2 && (
          <ButtonHLPure
            onClickBtn={() => {
              pad.current.clear()
              setUserDataInCanvas()
            }}
            nameBtn="Limpiar"
          />
        )}
        {step === 2 && (
          <ButtonHLPure
            onClickBtn={() => {
              setImgSignature(saveImage())
              setStep(1)
            }}
            primary
            nameBtn={"Capturar Firma"}
          />
        )}
        {step === 3 && (
          <ButtonHLPure
            onClickBtn={() =>
              setStep(0)
            }
            primary
            nameBtn={"Cargar imágenes"}
          />
        )}
      </div>
      <input
        ref={inputFrontIne}
        onChange={(e) => onImageChange(e, setIneFront, "ineFrontImage")}
        type="file"
        id="fileKey"
        // accept="image/*"
        accept=".jpg, .jpeg, .png"
        style={{ display: "none" }}
      />
      <input
        ref={inputBackIne}
        onChange={(e) => onImageChange(e, setIineBack, "ineBackImage")}
        type="file"
        id="fileKey"
        // accept="image/*"
        accept=".jpg, .jpeg, .png"
        style={{ display: "none" }}
      />
    </Dialog>
  );
}
